/* Plantilla de colección Temporada · Alba Beltrán */
(function () {
  // Bolitas de color: cambian la foto y el enlace de la tarjeta
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('.tt-color');
    if (!boton) return;
    e.preventDefault();
    var card = boton.closest('.tt-card');
    if (!card) return;
    var img = card.querySelector('.tt-card__img');
    if (img && boton.dataset.src) {
      if (boton.dataset.srcset) img.srcset = boton.dataset.srcset;
      img.src = boton.dataset.src;
    }
    if (boton.dataset.url) {
      card.querySelectorAll('.tt-card__link').forEach(function (a) { a.href = boton.dataset.url; });
    }
    card.querySelectorAll('.tt-color').forEach(function (x) {
      var activo = x === boton;
      x.classList.toggle('is-active', activo);
      x.setAttribute('aria-pressed', activo ? 'true' : 'false');
    });
  });

  // Scroll infinito: carga la siguiente página al llegar al final
  if (!customElements.get('temporada-scroll')) {
    customElements.define('temporada-scroll', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.next) return;
        this.observer = new IntersectionObserver((entradas) => {
          if (entradas[0].isIntersecting) this.cargar();
        }, { rootMargin: '800px 0px' });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      async cargar() {
        if (this.cargando || !this.dataset.next) return;
        this.cargando = true;
        this.classList.add('is-loading');
        let ok = false;
        try {
          const url = new URL(this.dataset.next, window.location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          const respuesta = await fetch(url.toString());
          const html = await respuesta.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = document.getElementById('product-grid');
          doc.querySelectorAll('#product-grid > li').forEach((li) => {
            grid.appendChild(document.importNode(li, true));
          });
          const siguiente = doc.querySelector('temporada-scroll');
          if (siguiente && siguiente.dataset.next) {
            this.dataset.next = siguiente.dataset.next;
          } else {
            this.dataset.next = '';
            if (this.observer) this.observer.disconnect();
            this.remove();
            return;
          }
          ok = true;
        } catch (error) {
          console.error('Temporada: no se pudieron cargar más productos', error);
        }
        this.cargando = false;
        this.classList.remove('is-loading');
        if (ok && this.getBoundingClientRect().top < window.innerHeight + 800) this.cargar();
      }
    });
  }
})();
